/* The Jerky Co: UFO: Abduct the Jerky. Used by sections/ufo-game.liquid.
   Ported from the standalone ufo-game.html (16/10/2026): scoped to its section, recoloured to the
   UFO palette, config read from the section settings. Gameplay code is unchanged. */
(() => {
'use strict';
const instances = new Map();

function boot(root) {
if (!root || instances.has(root)) return;
const cleanups = [];
let alive = true, rafId = 0;
const on = (t, ev, fn, opt) => { t.addEventListener(ev, fn, opt); cleanups.push(() => t.removeEventListener(ev, fn, opt)); };
const later = (fn, ms) => setTimeout(() => { if (alive) fn(); }, ms);
let cfg = {};
try { cfg = JSON.parse((root.querySelector('script[data-ufg-config]') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
const pick = (v, d) => (v === undefined || v === null ? d : v);


const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

/* =====================================================================
   CONFIG: change these values, no need to touch the game code below.
   ===================================================================== */
const CONFIG = {
  // Clearing every wave unlocks the shop button.
  SHOP_URL: pick(cfg.shopUrl, '/pages/ufo-products'),          // page the unlock button opens
  PRODUCT_NAME: pick(cfg.productName, 'UFO: Unidentified Flavoured Objects'),
  PRODUCT_IMAGE: pick(cfg.productImage, ''),  // UFO pack shot for the unlock screen
  TRANSMISSION: pick(cfg.transmission, "You've been granted secret access."),
  COORDINATES: pick(cfg.coordinates, ''),     // signal origin ('' to hide)

  // Logos: white versions for the dark background, from the brand hub.
  // Swap for Shopify CDN URLs if you host the game there.
  LOGO_ROUND: pick(cfg.logoRound, ''),
  LOGO_HORIZONTAL: pick(cfg.logoHorizontal, ''),

  // Packet artwork. Leave empty ('' or []) to use the drawn placeholder bags.
  // Use transparent PNGs, roughly 3:4 portrait. (Remote images won't load in the
  // claude.ai preview, but will once embedded on Shopify.)
  PACKET_IMAGES: Array.isArray(cfg.packetImages) ? cfg.packetImages.filter(Boolean) : [],                // e.g. ['https://cdn.shopify.com/.../traditional.png', ...]
  GOLDEN_IMAGE: pick(cfg.goldenImage, ''),   // rare bonus packet: 2X points (shows up twice as often in the final wave)
  SHIP_IMAGE: pick(cfg.shipImage, ''),         // player ship artwork (drawn ship if empty or still loading)
  MYSTERY_IMAGE: pick(cfg.mysteryImage, ''),  // UFO pack art

  WAVES: 5,
  BOSS_WAVES: { 3: 'pumpkin', 5: 'reaper' },  // which wave gets which boss
  ASTEROID_WAVES: [2, 4],
  LIVES: clamp(parseInt(cfg.lives, 10) || 4, 1, 6),
  CRT_DEFAULT: pick(cfg.crt, true),               // retro scanlines on by default

  // Overall difficulty. 1 is the tuned default; 0.8 is gentler, 1.2 is harder.
  DIFFICULTY: clamp(parseFloat(cfg.difficulty) || 1, 0.6, 1.5),
  BOSS_HP: { pumpkin: 32, reaper: 52 },

  // Tuned so an average player meets both bosses before reaching 1,000
  POINTS: { packet: 10, golden: 50, mystery: 100, candyCorn: 2, ghost: 3, bat: 4, asteroid: 10,
            pumpkin: 150, reaper: 250, waveClear: 10, lifeLeft: 50 },
  CHANCE: { golden: 0.08, mystery: 0.03 },
  DOUBLE_POINTS_SECONDS: 6,

  COLOURS: {
    bg: '#0A290A', lime: '#90FF00', limeSoft: '#C2FF73', limeDim: '#5AA904', mountain: '#2C600B',
    white: '#FFFFFF', gold: '#E8C14A', orange: '#F4731C', purple: '#A8228F', candyYellow: '#F6C945',
    ghost: '#EDEFF2', pumpkin: '#F4731C', pumpkinDark: '#B5480C', stem: '#4E6B2E', glow: '#FFD45C',
    jerky: '#7A2E1C', jerkyDark: '#4A170D', jerkyLight: '#A8492C', ember: '#FF4A1C', hellRed: '#EA0A1B', rock: '#2B3B30', rockEdge: '#56715A'
  },
  // Placeholder bag colours, from the core range
  FLAVOURS: ['#3053C1', '#F4731C', '#A8228F', '#EA0A1B', '#707070', '#AD000D'],

  WAVE_LINES: [
    'They came for the jerky.',
    'Sugar rush incoming. Mind the rocks.',
    'The patch has turned. Something big is rising.',
    'The bats are back. Faster.',
    'Something hot is rising. Final encounter.'
  ],
  BOSS_NAMES: { reaper: 'REAPER JERKY SKULL', pumpkin: 'MEGA PUMPKIN' },
  LOSE_LINES: [
    'They came for the jerky. You got in the way.',
    'Beam me up, Snacky.',
    'Lost to the sugar rush. Tragic.',
    'Houston, we have a lolly problem.'
  ],
  WIN_LINE: pick(cfg.winLine, "The aliens kept their word. Here's what they've been hiding.")
};
/* ===================================================================== */

const C = CONFIG.COLOURS;
const FONT = "Jost, Futura, 'Arial Narrow', sans-serif";
const DISPLAY = "Orbitron, Eurostile, 'Arial Black', sans-serif";
const HEADING = "Kusanagi, Orbitron, 'Arial Black', sans-serif";   // wave banner, as on the UFO pages
const TAU = Math.PI * 2;
const $ = id => root.querySelector('[data-ufg="' + id + '"]');
const stage = $('stage'), frame = $('frame'), canvas = $('game'), ctx = canvas.getContext('2d');
const controls = $('controls'), beamBtn = $('beamBtn');
const RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
const rand = (a, b) => a + Math.random() * (b - a);

function loadImg(src) { if (!src) return null; const i = new Image(); i.src = src; return i; }
const imgReady = i => i && i.complete && i.naturalWidth > 0;
const IMG = { packets: CONFIG.PACKET_IMAGES.map(loadImg), golden: loadImg(CONFIG.GOLDEN_IMAGE), mystery: loadImg(CONFIG.MYSTERY_IMAGE), ship: loadImg(CONFIG.SHIP_IMAGE) };

/* ---------- storage ---------- */
function getBest() { try { return parseInt(localStorage.getItem('tjc-ufo-best') || '0', 10) || 0; } catch (e) { return 0; } }
function setBest(v) { try { localStorage.setItem('tjc-ufo-best', String(v)); } catch (e) {} }

/* ---------- sound (Web Audio, no files) ---------- */
const sfx = {
  on: true, ctx: null, master: null, humGain: null, noiseBuf: null, humOn: false,
  init() {
    this.unlockIOS();
    if (this.ctx) { if (this.ctx.state !== 'running') this.ctx.resume().catch(() => {}); return; }
    try {
      // iPhones mute Web Audio when the side switch is on silent; 'playback' makes it behave like a game
      try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (_) {}
      const AC = window.AudioContext || window.webkitAudioContext; this.ctx = new AC();
      if (this.ctx.state !== 'running') this.ctx.resume().catch(() => {});
      this.master = this.ctx.createGain(); this.master.gain.value = this.on ? 0.5 : 0; this.master.connect(this.ctx.destination);
      const len = this.ctx.sampleRate; this.noiseBuf = this.ctx.createBuffer(1, len, this.ctx.sampleRate);
      const d = this.noiseBuf.getChannelData(0); for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
      const o = this.ctx.createOscillator(); o.type = 'sawtooth'; o.frequency.value = 84;
      const f = this.ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 460;
      const lfo = this.ctx.createOscillator(); lfo.frequency.value = 7; const lg = this.ctx.createGain(); lg.gain.value = 16;
      lfo.connect(lg); lg.connect(o.frequency);
      this.humGain = this.ctx.createGain(); this.humGain.gain.value = 0;
      o.connect(f); f.connect(this.humGain); this.humGain.connect(this.master); o.start(); lfo.start();
    } catch (e) { this.ctx = null; }
  },
  // Older iPhones: a looping silent <audio> track switches the page out of 'ringer' audio, so sound plays on silent mode
  unlockIOS() {
    if (!this.on) return;
    if (this.silent) { if (this.silent.paused) { const p = this.silent.play(); if (p && p.catch) p.catch(() => {}); } return; }
    try {
      const sr = 8000, n = 800, buf = new ArrayBuffer(44 + n * 2), v = new DataView(buf);
      const w = (o, str) => { for (let i = 0; i < str.length; i++) v.setUint8(o + i, str.charCodeAt(i)); };
      w(0, 'RIFF'); v.setUint32(4, 36 + n * 2, true); w(8, 'WAVE'); w(12, 'fmt '); v.setUint32(16, 16, true);
      v.setUint16(20, 1, true); v.setUint16(22, 1, true); v.setUint32(24, sr, true); v.setUint32(28, sr * 2, true);
      v.setUint16(32, 2, true); v.setUint16(34, 16, true); w(36, 'data'); v.setUint32(40, n * 2, true);
      let bin = ''; const u = new Uint8Array(buf); for (let i = 0; i < u.length; i++) bin += String.fromCharCode(u[i]);
      const a = new Audio('data:audio/wav;base64,' + btoa(bin)); a.loop = true; a.setAttribute('playsinline', '');
      const p = a.play(); if (p && p.catch) p.catch(() => {});
      this.silent = a;
    } catch (_) {}
  },
  tone(f1, f2, dur, type = 'square', vol = 0.12, delay = 0) {
    const c = this.ctx; if (!c) return; const t = c.currentTime + delay;
    const o = c.createOscillator(), g = c.createGain(); o.type = type;
    o.frequency.setValueAtTime(f1, t); if (f2) o.frequency.exponentialRampToValueAtTime(f2, t + dur);
    g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.001, t + dur);
    o.connect(g); g.connect(this.master); o.start(t); o.stop(t + dur + 0.02);
  },
  noise(dur, vol = 0.25, freq = 1200) {
    const c = this.ctx; if (!c) return; const t = c.currentTime;
    const s = c.createBufferSource(); s.buffer = this.noiseBuf;
    const f = c.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = freq;
    const g = c.createGain(); g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.001, t + dur);
    s.connect(f); f.connect(g); g.connect(this.master); s.start(t); s.stop(t + dur);
  },
  laser() { this.tone(1500, 520, 0.07, 'square', 0.03); },
  pop() { this.noise(0.12, 0.14, 2200); this.tone(320, 120, 0.1, 'square', 0.05); },
  collect() { [660, 880, 1320].forEach((f, i) => this.tone(f, null, 0.08, 'square', 0.07, i * 0.05)); },
  bonus() { [523, 659, 784, 1047, 1319].forEach((f, i) => this.tone(f, null, 0.1, 'square', 0.08, i * 0.06)); },
  hit() { this.noise(0.35, 0.35, 600); this.tone(240, 60, 0.35, 'sawtooth', 0.1); },
  boom() { this.noise(1.0, 0.45, 320); this.tone(130, 30, 0.9, 'sawtooth', 0.14); },
  bossShot() { this.tone(200, 90, 0.15, 'square', 0.05); },
  wave() { [392, 523, 659, 784].forEach((f, i) => this.tone(f, null, 0.12, 'triangle', 0.1, i * 0.09)); },
  beam(on) {
    if (!this.humGain || on === this.humOn) return; this.humOn = on;
    const t = this.ctx.currentTime; this.humGain.gain.cancelScheduledValues(t);
    this.humGain.gain.setTargetAtTime(on ? 0.09 : 0, t, 0.05);
  },
  setOn(v) { this.on = v; if (this.master) this.master.gain.value = v ? 0.5 : 0; if (!v && this.silent) this.silent.pause(); },
  // Paused, game over, hidden or scrolled away: stop the silent iOS track (it pauses the player's music) and idle the audio
  sleep() {
    if (this.silent) this.silent.pause();
    if (this.ctx && this.ctx.state === 'running') this.ctx.suspend().catch(() => {});
  },
  destroy() {
    this.sleep(); if (this.silent) { this.silent.removeAttribute('src'); this.silent = null; }
    if (this.ctx) { this.ctx.close().catch(() => {}); this.ctx = null; }
  }
};

/* ---------- on-screen tracking (Shopify page: the game is a section, not the whole page) ---------- */
let inView = true;
if (window.IntersectionObserver) {
  const io = new IntersectionObserver(([en]) => {
    inView = en.isIntersecting && en.intersectionRatio > 0.35;
    if (!inView) { setPaused(true); input.left = input.right = input.beamKey = input.beamTouch = false; }
  }, { threshold: [0, 0.35, 0.6] });
  io.observe(root); cleanups.push(() => io.disconnect());
}
// On a phone the promo bar pushes the game partly below the fold; line it up when a mission starts
function bringIntoView() {
  const r = stage.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
  if (r.top < 0 || r.bottom > vh + 1) stage.scrollIntoView({ block: 'end', behavior: RM ? 'auto' : 'smooth' });
}

/* ---------- layout ---------- */
const BAR = 86, UFO_Y = 118;
let W = 360, H = 640, scale = 1, dpr = 1, groundTop = 500;
let bdBack = null, bdFront = null, stars = [];

function resize() {
  if (!alive) return;
  const cw = stage.clientWidth, ch = stage.clientHeight;
  const fw = Math.min(cw, 480, ch / 1.5);
  frame.style.width = fw + 'px';
  scale = fw / 360; W = 360; H = ch / scale;
  dpr = Math.min(window.devicePixelRatio || 1, 2);
  canvas.width = Math.round(fw * dpr); canvas.height = Math.round(ch * dpr);
  controls.style.height = (BAR * scale) + 'px';
  groundTop = H - BAR - 64;
  buildBackdrop();
  if (player) player.x = clamp(player.x, 32, W - 32);
  if (boss) boss.targetY = groundTop - 150;
}

function seeded(s) { return () => { s = (s * 16807) % 2147483647; return s / 2147483647; }; }

function pine(b, x, base, h) {
  const tiers = 4;
  for (let i = 0; i < tiers; i++) {
    const top = base - h + i * h * 0.2, w = h * (0.16 + i * 0.09);
    b.beginPath(); b.moveTo(x, top); b.lineTo(x + w, top + h * 0.34); b.lineTo(x - w, top + h * 0.34); b.closePath(); b.fill();
  }
  b.fillRect(x - 1.5, base - h * 0.2, 3, h * 0.2);
}

function cloud(b, x, y, s) {
  b.beginPath();
  b.moveTo(x - 6 * s, y); b.arc(x + 4 * s, y, 10 * s, Math.PI, Math.PI * 1.9);
  b.arc(x + 20 * s, y - 2 * s, 12 * s, Math.PI * 1.1, Math.PI * 1.95);
  b.arc(x + 36 * s, y, 8 * s, Math.PI * 1.15, 0);
  b.stroke();
  b.beginPath(); b.moveTo(x - 26 * s, y + 4 * s); b.lineTo(x + 60 * s, y + 4 * s); b.stroke();
  b.beginPath(); b.moveTo(x - 10 * s, y + 10 * s); b.lineTo(x + 30 * s, y + 10 * s); b.stroke();
}

function buildBackdrop() {
  const make = () => { const c = document.createElement('canvas'); c.width = canvas.width; c.height = canvas.height;
    const b = c.getContext('2d'); b.setTransform(scale * dpr, 0, 0, scale * dpr, 0, 0); return [c, b]; };
  const r = seeded(11);
  let b; [bdBack, b] = make();
  b.strokeStyle = C.lime; b.lineWidth = 2; b.lineCap = 'round'; b.globalAlpha = 0.85;
  cloud(b, 30, groundTop - 120, 1); cloud(b, 262, groundTop - 92, 0.95);
  b.globalAlpha = 1;
  b.fillStyle = C.mountain; b.beginPath(); b.moveTo(0, groundTop + 20);
  const peaks = [[30, -26], [80, 4], [140, -58], [200, -14], [250, -44], [310, 2], [360, -24]];
  peaks.forEach(([x, dy]) => b.lineTo(x, groundTop + dy));
  b.lineTo(W, H); b.lineTo(0, H); b.closePath(); b.fill();

  let f; [bdFront, f] = make();
  f.fillStyle = '#103810';
  for (let x = -6; x < W + 10; x += 17) pine(f, x + r() * 6, groundTop + 50, 46 + r() * 30);
  f.fillStyle = C.bg;
  for (let x = -10; x < W + 14; x += 13) pine(f, x + r() * 5, groundTop + 64, 40 + r() * 46);
  f.fillRect(0, groundTop + 60, W, H);

  stars = [];
  const rs = seeded(29);
  for (let i = 0; i < 70; i++) stars.push({ x: rs() * W, y: 40 + rs() * (groundTop - 80), big: rs() < 0.14, r: 0.8 + rs() * 1.2, ph: rs() * TAU, sp: 0.6 + rs() * 1.8 });
}

/* ---------- state ---------- */
const S = { mode: 'title', t: 0, score: 0, lives: 3, wave: 0, combo: 0, energy: 100, beaming: false,
  invuln: 0, doubleT: 0, shake: 0, fireT: 0, pktT: 1, astT: 4, nextWaveT: 0, waveDone: false, waveKind: 'formation', banner: null, dieT: 0 };
let player = null, enemies = [], crumbs = [], lasers = [], packets = [], asteroids = [], particles = [], floaters = [], boss = null;
const input = { left: false, right: false, beamKey: false, beamTouch: false, dragId: null, dragStartX: 0, dragUfoX: 0, targetX: 180 };

/* ---------- helpers ---------- */
function rr(c, x, y, w, h, r) {
  c.beginPath(); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r);
  c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath();
}
function burst(x, y, col, n, spd = 130) {
  for (let i = 0; i < n; i++) { const a = Math.random() * TAU, v = Math.random() * spd;
    particles.push({ x, y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life: rand(0.35, 0.9), max: 0.9, col, s: rand(2, 4) }); }
}
function floater(x, y, text, col = C.limeSoft, size = 14) { floaters.push({ x, y, text, col, size, t: 1 }); }
function addShake(v) { if (!RM) S.shake = Math.max(S.shake, v); }
function comboMult() { return Math.min(3, 1 + Math.floor(S.combo / 4) * 0.5); }
function addScore(base, x, y, col, isPacket) {
  const pts = Math.round(base * (isPacket ? comboMult() : 1) * (S.doubleT > 0 ? 2 : 1));
  S.score += pts; floater(x, y, '+' + pts, col);
}
const beamLen = () => Math.min(400, groundTop - player.y - 10);
function inBeam(x, y) {
  if (!S.beaming) return false;
  const top = player.y + 10, len = beamLen();
  if (y < top || y > top + len) return false;
  return Math.abs(x - player.x) < 12 + ((y - top) / len) * 58;
}

/* ---------- waves ---------- */
const ROW_TYPES = ['candyCorn', 'ghost', 'bat'];   // bottom row to top row
const ENEMY_COL = { candyCorn: C.candyYellow, ghost: C.ghost, bat: C.purple };
const BOSS_COL = { reaper: C.ember, pumpkin: C.pumpkin };
function spawnFormation(rows) {
  enemies = []; const cols = 6, sx = 42, sy = 34, x0 = (W - (cols - 1) * sx) / 2;
  for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++)
    enemies.push({ x: x0 + c * sx, y: groundTop - 36 - r * sy + 100, type: ROW_TYPES[Math.min(r, 2)], alive: true });
  S.formation = { dir: 1, rise: 100, total: enemies.length, fireT: 2.4, anim: 0 };
}
function spawnBoss(kind) {
  const hp = Math.round(CONFIG.BOSS_HP[kind] * CONFIG.DIFFICULTY);
  const size = kind === 'pumpkin' ? { w: 140, h: 110 } : { w: 118, h: 150 };
  boss = { kind, x: W / 2, y: groundTop + 80, targetY: groundTop - 150, ...size, hp, maxHp: hp, t: 0, fireT: 2.6, flash: 0 };
}

function startWave(n) {
  S.wave = n; S.waveDone = false; S.nextWaveT = 0; crumbs = []; asteroids = []; enemies = []; boss = null;
  S.banner = { text: 'WAVE ' + n, sub: CONFIG.WAVE_LINES[n - 1] || '', t: 2.4 };
  const bk = CONFIG.BOSS_WAVES[n];
  if (bk) { S.waveKind = 'boss'; spawnBoss(bk); }
  else { S.waveKind = 'formation'; spawnFormation(3); }
  S.astT = rand(5, 7); sfx.wave();
}

function startGame() {
  sfx.init(); bringIntoView();
  Object.assign(S, { mode: 'play', t: 0, score: 0, lives: CONFIG.LIVES, combo: 0, energy: 100, beaming: false,
    invuln: 0, doubleT: 0, shake: 0, fireT: 0.4, pktT: 0.8 });
  player = { x: W / 2, y: UFO_Y, tilt: 0 }; input.targetX = W / 2;
  crumbs = []; lasers = []; packets = []; particles = []; floaters = [];
  ['title', 'brief', 'end', 'pause'].forEach(id => $(id).hidden = true);
  controls.hidden = false; $('pauseBtn').hidden = false; $('hudLogo').hidden = !$('hudLogo').dataset.ok;
  startWave(1);
}

function endGame(win) {
  S.mode = 'over'; sfx.beam(false); controls.hidden = true; $('pauseBtn').hidden = true; $('hudLogo').hidden = true;
  if (win) { const bonus = S.lives * CONFIG.POINTS.lifeLeft; S.score += bonus; }
  const best = Math.max(getBest(), S.score); setBest(best);
  $('endTitle').textContent = win ? 'ACCESS UNLOCKED' : 'ACCESS DENIED';
  $('endLine').textContent = win ? CONFIG.WIN_LINE : CONFIG.LOSE_LINES[Math.random() * CONFIG.LOSE_LINES.length | 0];
  $('endScore').textContent = S.score.toLocaleString('en-AU');
  $('endBest').textContent = best.toLocaleString('en-AU');
  $('reward').hidden = !win; $('endHint').hidden = win;
  $('endHint').textContent = `Clear all ${CONFIG.WAVES} waves to unlock what the aliens are hiding.`;
  $('productName').textContent = CONFIG.PRODUCT_NAME;
  $('shopBtn').href = CONFIG.SHOP_URL || '/pages/ufo-products';
  $('againBtn').textContent = win ? 'PLAY AGAIN' : 'TRY AGAIN';
  $('end').hidden = false;
  if (win) sfx.bonus();
  later(() => { if (S.mode === 'over') sfx.sleep(); }, 1800);
}

function goTitle() {
  S.mode = 'title'; sfx.beam(false); controls.hidden = true; $('pauseBtn').hidden = true; $('hudLogo').hidden = true;
  ['brief', 'end', 'pause'].forEach(id => $(id).hidden = true); $('title').hidden = false;
  player = null; enemies = []; crumbs = []; lasers = []; packets = []; asteroids = []; boss = null;
  sfx.sleep();
}
function setPaused(p) {
  if (p && S.mode === 'play') { S.mode = 'paused'; sfx.beam(false); sfx.sleep(); $('pause').hidden = false; }
  else if (!p && S.mode === 'paused') { S.mode = 'play'; sfx.init(); $('pause').hidden = true; last = performance.now(); }
}

/* ---------- damage ---------- */
function hurt() {
  if (S.invuln > 0 || S.mode !== 'play') return false;
  S.lives--; S.combo = 0; S.invuln = 2.2; addShake(12); burst(player.x, player.y, C.lime, 18); sfx.hit();
  if (S.lives <= 0) { S.mode = 'dying'; S.dieT = 1.5; S.beaming = false; sfx.beam(false);
    burst(player.x, player.y, C.white, 30, 220); burst(player.x, player.y, C.lime, 40, 180); sfx.boom(); addShake(18); }
  return true;
}

/* ---------- update ---------- */
function updatePlayer(dt) {
  const want = input.beamKey || input.beamTouch;
  S.beaming = want && S.energy > 0 && (S.beaming || S.energy > 15);
  if (S.beaming) S.energy = Math.max(0, S.energy - 25 * dt); else S.energy = Math.min(100, S.energy + 24 * dt);
  sfx.beam(S.beaming);

  const maxV = S.beaming ? 150 : 540; const before = player.x;
  if (input.dragId !== null) player.x += clamp(input.targetX - player.x, -maxV * dt, maxV * dt);
  player.x += (input.right - input.left) * (S.beaming ? 120 : 270) * dt;
  player.x = clamp(player.x, 32, W - 32);
  player.tilt += (clamp((player.x - before) / Math.max(dt, 0.001) / 900, -0.25, 0.25) - player.tilt) * Math.min(1, dt * 10);

  if (!S.beaming) { S.fireT -= dt; if (S.fireT <= 0) { lasers.push({ x: player.x, y: player.y + 14 }); S.fireT = 0.27; sfx.laser(); } }
}

function updateFormation(dt) {
  const F = S.formation; const alive = enemies.filter(e => e.alive); if (!alive.length) return;
  F.anim += dt;
  if (F.rise > 0) { const d = Math.min(F.rise, 110 * dt); F.rise -= d; alive.forEach(e => e.y -= d); return; }
  const spd = (16 + S.wave * 5) * (1 + (1 - alive.length / F.total) * 1.2) * CONFIG.DIFFICULTY;
  let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
  alive.forEach(e => { e.x += F.dir * spd * dt; minX = Math.min(minX, e.x); maxX = Math.max(maxX, e.x); minY = Math.min(minY, e.y); maxY = Math.max(maxY, e.y); });
  if ((maxX > W - 20 && F.dir > 0) || (minX < 20 && F.dir < 0)) { F.dir *= -1; alive.forEach(e => e.y -= 12); }

  F.fireT -= dt;
  if (F.fireT <= 0) {
    F.fireT = Math.max(0.8, 1.9 - S.wave * 0.15) / CONFIG.DIFFICULTY * rand(0.7, 1.3);
    const pick = alive[Math.random() * alive.length | 0]; let sh = pick;
    alive.forEach(e => { if (Math.abs(e.x - pick.x) < 4 && e.y < sh.y) sh = e; });
    crumbs.push({ x: sh.x, y: sh.y - 12, vx: rand(-8, 8), vy: -(115 + S.wave * 12) * CONFIG.DIFFICULTY, rot: 0, kind: 'lolly', col: Math.random() < 0.5 ? C.orange : C.purple });
  }
  if (minY < player.y + 44) {
    hurt(); floater(W / 2, player.y + 70, 'INVASION!', C.orange, 18);
    const shift = Math.max(0, Math.min(160, groundTop - 36 - maxY)); alive.forEach(e => e.y += shift);
  }
}

function updateBoss(dt) {
  const b = boss; b.t += dt; b.flash = Math.max(0, b.flash - dt);
  if (b.y > b.targetY) b.y = Math.max(b.targetY, b.y - 60 * dt);
  b.x = W / 2 + Math.sin(b.t * 0.7) * (W / 2 - b.w / 2 - 14);
  b.fireT -= dt;
  if (b.fireT <= 0 && b.y <= b.targetY + 1) {
    const rage = b.hp < b.maxHp / 2, n = rage ? 4 : 3, spread = rage ? 0.9 : 0.6, v = (130 + S.wave * 8) * CONFIG.DIFFICULTY;
    const kind = b.kind === 'pumpkin' ? 'seed' : 'flame';
    for (let i = 0; i < n; i++) { const a = -spread / 2 + spread * i / (n - 1);
      crumbs.push({ x: b.x + Math.sin(a) * 24, y: b.y - b.h / 2, vx: Math.sin(a) * v, vy: -Math.cos(a) * v, rot: 0, kind }); }
    b.fireT = (rage ? 1.25 : 1.8) / CONFIG.DIFFICULTY; sfx.bossShot();
  }
}

function spawnPacket() {
  const r = Math.random(); const kind = r < CONFIG.CHANCE.mystery ? 'mystery' : r < CONFIG.CHANCE.mystery + CONFIG.CHANCE.golden * (S.wave === CONFIG.WAVES ? 2 : 1) ? 'gold' : 'std';
  const fromLeft = Math.random() < 0.5, speed = rand(48, 88) * (kind === 'std' ? 1 : 1.25);
  packets.push({ x: fromLeft ? -20 : W + 20, y: rand(player.y + 100, groundTop - 70), vx: fromLeft ? speed : -speed, vy: 0,
    ph: Math.random() * TAU, rot: rand(-0.3, 0.3), vr: rand(-1, 1), kind, flav: Math.random() * CONFIG.FLAVOURS.length | 0, beamed: false });
}
function spawnAsteroid() {
  const fromLeft = Math.random() < 0.5, r = rand(13, 20), pts = [];
  for (let i = 0; i < 9; i++) pts.push(r * rand(0.72, 1.08));
  asteroids.push({ x: fromLeft ? -r : W + r, y: rand(player.y + 60, groundTop - 90), vx: (fromLeft ? 1 : -1) * rand(45, 75), vy: rand(-28, 18),
    r, pts, hp: 2, rot: 0, vr: rand(-1.5, 1.5), flash: 0 });
}

function updateEffects(dt) {
  particles.forEach(p => { p.x += p.vx * dt; p.y += p.vy * dt; p.vx *= 0.97; p.vy *= 0.97; p.life -= dt; });
  particles = particles.filter(p => p.life > 0);
  floaters.forEach(f => { f.y -= 32 * dt; f.t -= dt; }); floaters = floaters.filter(f => f.t > 0);
  S.shake = Math.max(0, S.shake - 40 * dt);
  if (S.banner) { S.banner.t -= dt; if (S.banner.t <= 0) S.banner = null; }
}

function update(dt) {
  S.t += dt;
  if (S.mode === 'dying') { S.dieT -= dt; updateEffects(dt); crumbs.forEach(c => { c.x += c.vx * dt; c.y += c.vy * dt; }); if (S.dieT <= 0) endGame(false); return; }
  S.invuln = Math.max(0, S.invuln - dt); S.doubleT = Math.max(0, S.doubleT - dt);
  updatePlayer(dt);

  S.pktT -= dt; if (S.pktT <= 0) { spawnPacket(); S.pktT = rand(1.4, 2.3) + S.wave * 0.08; }
  if (CONFIG.ASTEROID_WAVES.includes(S.wave)) { S.astT -= dt; if (S.astT <= 0) { spawnAsteroid(); S.astT = rand(5, 8); } }

  if (S.waveKind === 'formation') updateFormation(dt); else if (boss) updateBoss(dt);

  // lasers
  for (const L of lasers) {
    L.y += 470 * dt; if (L.y > groundTop + 8) { L.dead = true; continue; }
    for (const e of enemies) {
      if (e.alive && Math.abs(L.x - e.x) < 15 && Math.abs(L.y - e.y) < 13) {
        e.alive = false; L.dead = true;
        const col = ENEMY_COL[e.type];
        addScore(CONFIG.POINTS[e.type], e.x, e.y, col);
        burst(e.x, e.y, col, 12); burst(e.x, e.y, C.white, 4); sfx.pop(); break;
      }
    }
    if (!L.dead && boss && Math.abs(L.x - boss.x) < boss.w / 2 && Math.abs(L.y - boss.y) < boss.h / 2) {
      L.dead = true; boss.hp--; boss.flash = 0.06; const bc = BOSS_COL[boss.kind]; burst(L.x, L.y, bc, 3, 80);
      if (boss.hp <= 0) {
        addScore(CONFIG.POINTS[boss.kind], boss.x, boss.y, C.gold);
        for (let i = 0; i < 5; i++) burst(boss.x + rand(-55, 55), boss.y + rand(-40, 40), i % 2 ? bc : C.white, 18, 200);
        sfx.boom(); addShake(20); boss = null;
      }
    }
    if (!L.dead) for (const a of asteroids) {
      if (Math.hypot(L.x - a.x, L.y - a.y) < a.r + 2) { L.dead = true; a.hp--; a.flash = 0.06;
        if (a.hp <= 0) { a.dead = true; addScore(CONFIG.POINTS.asteroid, a.x, a.y, C.limeSoft); burst(a.x, a.y, C.rockEdge, 16, 150); sfx.pop(); }
        break; }
    }
  }
  lasers = lasers.filter(l => !l.dead);

  // crumbs
  for (const c of crumbs) {
    c.x += c.vx * dt; c.y += c.vy * dt; c.rot += dt * 8;
    if (c.y < -10 || c.x < -10 || c.x > W + 10) c.dead = true;
    else { const dx = (c.x - player.x) / 25, dy = (c.y - player.y) / 10; if (dx * dx + dy * dy < 1) { c.dead = true; hurt(); } }
  }
  crumbs = crumbs.filter(c => !c.dead);

  // asteroids
  for (const a of asteroids) {
    a.x += a.vx * dt; a.y += a.vy * dt; a.rot += a.vr * dt; a.flash = Math.max(0, a.flash - dt);
    if (a.x < -50 || a.x > W + 50) a.dead = true;
    if (a.y < player.y + 30) a.vy = Math.abs(a.vy);
    if (!a.dead && S.mode === 'play' && Math.hypot(a.x - player.x, a.y - player.y) < a.r + 22) {
      if (hurt()) { a.dead = true; burst(a.x, a.y, C.rockEdge, 16, 150); }
    }
  }
  asteroids = asteroids.filter(a => !a.dead);

  // packets
  for (const p of packets) {
    if (S.mode === 'play' && inBeam(p.x, p.y)) {
      p.beamed = true; p.vy = Math.max(-280, p.vy - 360 * dt); p.vx *= 0.9;
      p.x += (player.x - p.x) * Math.min(1, 3.2 * dt); p.y += p.vy * dt; p.rot += 6 * dt;
    } else {
      if (p.beamed) { p.vy += 240 * dt; if (p.vy > 0) { p.vy = 0; p.beamed = false; } p.y += p.vy * dt; }
      p.x += p.vx * dt; p.y += Math.sin(S.t * 2 + p.ph) * 10 * dt; p.rot += p.vr * dt;
    }
    if (S.mode === 'play' && p.y < player.y + 20 && Math.abs(p.x - player.x) < 28) {
      p.dead = true; S.combo++;
      if (p.kind === 'gold') { S.doubleT = CONFIG.DOUBLE_POINTS_SECONDS; addScore(CONFIG.POINTS.golden, p.x, p.y + 26, C.gold, true); floater(player.x, player.y + 52, '2X POINTS', C.gold, 16); sfx.bonus(); }
      else if (p.kind === 'mystery') { addScore(CONFIG.POINTS.mystery, p.x, p.y + 26, C.lime, true); floater(player.x, player.y + 52, 'MYSTERY ABDUCTED', C.lime, 16); sfx.bonus(); }
      else { addScore(CONFIG.POINTS.packet, p.x, p.y + 26, C.limeSoft, true); sfx.collect(); }
      burst(player.x, player.y + 8, p.kind === 'gold' ? C.gold : C.lime, 12, 90);
    }
    if (p.x < -40 || p.x > W + 40 || p.y > H) p.dead = true;
  }
  packets = packets.filter(p => !p.dead);

  updateEffects(dt);

  // wave progress
  if (S.mode === 'play' && !S.waveDone) {
    const done = S.waveKind === 'boss' ? boss === null : enemies.length > 0 && enemies.every(e => !e.alive);
    if (done) { S.waveDone = true; S.nextWaveT = 1.8; const b = CONFIG.POINTS.waveClear * S.wave; S.score += b;
      floater(W / 2, H * 0.42, 'WAVE CLEAR +' + b, C.lime, 20); crumbs = []; }
  }
  if (S.waveDone && S.mode === 'play') { S.nextWaveT -= dt; if (S.nextWaveT <= 0) { if (S.wave >= CONFIG.WAVES) endGame(true); else startWave(S.wave + 1); } }

  // beam button display
  beamBtn.style.setProperty('--e', S.energy.toFixed(0) + '%');
  beamBtn.classList.toggle('on', S.beaming);
  beamBtn.classList.toggle('low', !S.beaming && S.energy < 15);
}

/* ---------- drawing ---------- */
function star4(x, y, r) {
  ctx.beginPath(); ctx.moveTo(x, y - r); ctx.quadraticCurveTo(x, y, x + r, y); ctx.quadraticCurveTo(x, y, x, y + r);
  ctx.quadraticCurveTo(x, y, x - r, y); ctx.quadraticCurveTo(x, y, x, y - r); ctx.fill();
}
function drawStars() {
  ctx.fillStyle = C.lime;
  for (const s of stars) {
    ctx.globalAlpha = 0.35 + 0.65 * Math.abs(Math.sin(S.t * s.sp + s.ph));
    if (s.big) star4(s.x, s.y, 5 + s.r * 2); else { ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, TAU); ctx.fill(); }
  }
  ctx.globalAlpha = 1;
}

function drawUFO(x, y, tilt, glow) {
  ctx.save(); ctx.translate(x, y); ctx.rotate(tilt);
  if (imgReady(IMG.ship)) {
    // Ship artwork: same footprint as the drawn ship (72 wide, beam leaves from y + 10), lime underglow
    const sw = 76, sh = sw * IMG.ship.naturalHeight / IMG.ship.naturalWidth;
    ctx.save(); ctx.shadowColor = C.lime; ctx.shadowBlur = glow ? 18 : 8;
    ctx.drawImage(IMG.ship, -sw / 2, 11 - sh, sw, sh);
    ctx.restore();
    if (glow) { ctx.globalAlpha = 0.85; ctx.fillStyle = C.limeSoft; ctx.beginPath(); ctx.ellipse(0, 10, 9, 2.4, 0, 0, TAU); ctx.fill(); ctx.globalAlpha = 1; }
    ctx.restore(); return;
  }
  // underside glow
  ctx.fillStyle = glow ? C.white : C.limeSoft; ctx.beginPath(); ctx.ellipse(0, 8, 14, 5, 0, 0, TAU); ctx.fill();
  // dome
  ctx.fillStyle = C.lime; ctx.beginPath(); ctx.ellipse(0, -5, 17, 14, 0, Math.PI, 0); ctx.fill();
  ctx.strokeStyle = C.bg; ctx.lineWidth = 1.8;
  ctx.beginPath(); ctx.ellipse(0, -5, 11, 8, 0, Math.PI * 1.15, Math.PI * 1.85); ctx.stroke();
  // rim
  ctx.fillStyle = C.lime; ctx.beginPath(); ctx.ellipse(0, 0, 36, 9.5, 0, 0, TAU); ctx.fill();
  ctx.beginPath(); ctx.ellipse(0, 0.5, 29, 5.5, 0, 0, TAU); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(-34, -1); ctx.lineTo(34, -1); ctx.stroke();
  ctx.beginPath(); ctx.ellipse(0, 5, 18, 4, 0, 0, Math.PI); ctx.stroke();
  // lights
  for (let i = 0; i < 5; i++) {
    const on = (Math.floor(S.t * 6) % 5) === i; ctx.fillStyle = on ? C.white : C.bg;
    ctx.beginPath(); ctx.arc(-22 + i * 11, 2.5, 1.8, 0, TAU); ctx.fill();
  }
  ctx.restore();
}

function drawBeam(x, y) {
  const top = y + 10, len = Math.min(400, groundTop - y - 10), bot = top + len;
  const g = ctx.createLinearGradient(0, top, 0, bot);
  g.addColorStop(0, 'rgba(144,255,0,0.8)'); g.addColorStop(0.4, 'rgba(144,255,0,0.42)'); g.addColorStop(1, 'rgba(144,255,0,0)');  // beam: all UFO lime
  ctx.fillStyle = g; ctx.beginPath(); ctx.moveTo(x - 12, top); ctx.lineTo(x + 12, top); ctx.lineTo(x + 70, bot); ctx.lineTo(x - 70, bot); ctx.closePath(); ctx.fill();
  const eg = ctx.createLinearGradient(0, top, 0, bot); eg.addColorStop(0, C.lime); eg.addColorStop(1, 'rgba(144,255,0,0)');
  ctx.strokeStyle = eg; ctx.lineWidth = 3;
  ctx.beginPath(); ctx.moveTo(x - 12, top); ctx.lineTo(x - 70, bot); ctx.moveTo(x + 12, top); ctx.lineTo(x + 70, bot); ctx.stroke();
  ctx.lineWidth = 1.2;
  for (let k = 0; k < 5; k++) {
    const f = 1 - ((S.t * 0.9 + k / 5) % 1); const yy = top + f * len, hw = 12 + f * 58;
    ctx.strokeStyle = `rgba(144,255,0,${0.5 * (1 - f)})`; ctx.beginPath(); ctx.ellipse(x, yy, hw, hw * 0.16, 0, 0, TAU); ctx.stroke();
  }
}

function dot(x, y, r) { ctx.beginPath(); ctx.arc(x, y, r, 0, TAU); ctx.fill(); }
function drawCandyCorn(e, f) {
  ctx.save(); ctx.translate(e.x, e.y); ctx.rotate(f ? 0.09 : -0.09);
  ctx.beginPath(); ctx.moveTo(0, -13); ctx.quadraticCurveTo(14, 8, 11, 11); ctx.quadraticCurveTo(0, 14, -11, 11); ctx.quadraticCurveTo(-14, 8, 0, -13); ctx.closePath();
  ctx.save(); ctx.clip();
  ctx.fillStyle = C.candyYellow; ctx.fillRect(-15, 3, 30, 12);
  ctx.fillStyle = C.orange; ctx.fillRect(-15, -5, 30, 8);
  ctx.fillStyle = C.white; ctx.fillRect(-15, -14, 30, 9);
  ctx.restore();
  ctx.fillStyle = C.bg; dot(-3.5, 0, 1.6); dot(3.5, 0, 1.6);
  ctx.strokeStyle = C.bg; ctx.lineWidth = 1.4; ctx.beginPath(); ctx.arc(0, 4, 3, 0.25, Math.PI - 0.25); ctx.stroke();
  ctx.restore();
}
function drawGhost(e, f) {
  ctx.save(); ctx.translate(e.x, e.y + (f ? -1.5 : 1.5));
  ctx.fillStyle = C.ghost; ctx.beginPath();
  ctx.moveTo(-12, 10); ctx.lineTo(-12, -2); ctx.arc(0, -2, 12, Math.PI, 0); ctx.lineTo(12, 10);
  for (let i = 0; i < 4; i++) { const x0 = 12 - i * 6; ctx.quadraticCurveTo(x0 - 3, (i + (f ? 1 : 0)) % 2 ? 5 : 15, x0 - 6, 10); }
  ctx.closePath(); ctx.fill();
  ctx.fillStyle = C.bg;
  ctx.beginPath(); ctx.ellipse(-4.5, -3, 2.2, 3.2, 0, 0, TAU); ctx.fill();
  ctx.beginPath(); ctx.ellipse(4.5, -3, 2.2, 3.2, 0, 0, TAU); ctx.fill();
  ctx.beginPath(); ctx.ellipse(0, 4, 2.4, 3, 0, 0, TAU); ctx.fill();
  ctx.restore();
}
function drawBat(e, f) {
  const up = f ? -5 : 4;
  ctx.save(); ctx.translate(e.x, e.y); ctx.fillStyle = C.purple;
  for (const s of [-1, 1]) {
    ctx.beginPath(); ctx.moveTo(s * 4, -3); ctx.lineTo(s * 17, -5 + up); ctx.lineTo(s * 14, 2 + up * 0.4);
    ctx.lineTo(s * 11, 0); ctx.lineTo(s * 8, 5); ctx.lineTo(s * 4, 3); ctx.closePath(); ctx.fill();
  }
  ctx.beginPath(); ctx.ellipse(0, 1, 6, 7, 0, 0, TAU); ctx.fill();
  ctx.beginPath(); ctx.moveTo(-5, -4); ctx.lineTo(-4, -11); ctx.lineTo(-1, -5); ctx.moveTo(5, -4); ctx.lineTo(4, -11); ctx.lineTo(1, -5); ctx.fill();
  ctx.fillStyle = C.candyYellow; dot(-2.4, 0, 1.5); dot(2.4, 0, 1.5);
  ctx.fillStyle = C.white; ctx.beginPath(); ctx.moveTo(-2, 4); ctx.lineTo(-1, 7); ctx.lineTo(0, 4); ctx.moveTo(0, 4); ctx.lineTo(1, 7); ctx.lineTo(2, 4); ctx.fill();
  ctx.restore();
}
function flame(x, base, hgt, wid, ph) {
  const t = S.t, fk = Math.sin(t * 9 + ph) * 0.18 + Math.sin(t * 14 + ph * 2) * 0.1;
  ctx.beginPath(); ctx.moveTo(x - wid, base);
  ctx.quadraticCurveTo(x - wid, base - hgt * 0.55, x + wid * fk * 2.5, base - hgt * (1 + fk));
  ctx.quadraticCurveTo(x + wid, base - hgt * 0.55, x + wid, base); ctx.closePath(); ctx.fill();
}
function drawReaper(b) {
  const { x, y } = b, fl = b.flash > 0, rage = b.hp < b.maxHp / 2, fs = rage ? 1.35 : 1;
  // flames behind the hood
  ctx.save(); ctx.shadowColor = C.ember; ctx.shadowBlur = 16;
  const fx = [-74, -58, -42, -26, 26, 42, 58, 74];
  [[C.hellRed, 1, 1], [C.orange, 0.7, 0.68], [C.glow, 0.4, 0.42]].forEach(([col, hs, ws], li) => {
    ctx.fillStyle = col;
    fx.forEach((dx, i) => flame(x + dx, y - 6 + Math.abs(dx) * 0.4, (58 + (i % 3) * 18) * hs * fs, 15 * ws, i * 1.7 + li));
  });
  ctx.restore();
  // scythe: dark handle, yellow blade with a red inner edge
  ctx.strokeStyle = '#2B120C'; ctx.lineWidth = 5; ctx.lineCap = 'round';
  ctx.beginPath(); ctx.moveTo(x + 30, y + 72); ctx.lineTo(x + 64, y - 78); ctx.stroke();
  ctx.fillStyle = '#F6D21E'; ctx.beginPath(); ctx.moveTo(x + 66, y - 80);
  ctx.quadraticCurveTo(x + 18, y - 118, x - 52, y - 90); ctx.quadraticCurveTo(x + 8, y - 98, x + 60, y - 64); ctx.closePath(); ctx.fill();
  ctx.strokeStyle = C.hellRed; ctx.lineWidth = 2.5;
  ctx.beginPath(); ctx.moveTo(x - 40, y - 91); ctx.quadraticCurveTo(x + 8, y - 96, x + 56, y - 68); ctx.stroke();
  // hood and robe
  const hg = ctx.createLinearGradient(0, y - 84, 0, y + 75);
  hg.addColorStop(0, fl ? '#B04030' : '#5A1A16'); hg.addColorStop(1, fl ? '#702018' : '#1A0706');
  ctx.fillStyle = hg; ctx.beginPath(); ctx.moveTo(x, y - 84);
  ctx.bezierCurveTo(x + 40, y - 82, x + 54, y - 32, x + 50, y + 8); ctx.quadraticCurveTo(x + 66, y + 50, x + 60, y + 75);
  ctx.lineTo(x - 60, y + 75); ctx.quadraticCurveTo(x - 66, y + 50, x - 50, y + 8);
  ctx.bezierCurveTo(x - 54, y - 32, x - 40, y - 82, x, y - 84); ctx.fill();
  ctx.strokeStyle = '#8A2A1E'; ctx.lineWidth = 2; ctx.stroke();
  ctx.fillStyle = '#0D0303'; ctx.beginPath(); ctx.ellipse(x, y - 10, 34, 46, 0, 0, TAU); ctx.fill();
  // skull: bone white, red outline, angry
  ctx.beginPath(); ctx.moveTo(x - 26, y - 16);
  ctx.bezierCurveTo(x - 30, y - 56, x + 30, y - 56, x + 26, y - 16);
  ctx.quadraticCurveTo(x + 28, y + 1, x + 18, y + 7); ctx.lineTo(x + 16, y + 24);
  ctx.quadraticCurveTo(x, y + 32, x - 16, y + 24); ctx.lineTo(x - 18, y + 7);
  ctx.quadraticCurveTo(x - 28, y + 1, x - 26, y - 16); ctx.closePath();
  ctx.fillStyle = fl ? C.white : '#F2EEE6'; ctx.fill(); ctx.strokeStyle = C.hellRed; ctx.lineWidth = 3; ctx.stroke();
  for (const s of [-1, 1]) {
    ctx.fillStyle = C.hellRed; ctx.beginPath(); ctx.moveTo(x + s * 23, y - 24); ctx.lineTo(x + s * 3, y - 15);
    ctx.quadraticCurveTo(x + s * 4, y - 2, x + s * 13, y - 2); ctx.quadraticCurveTo(x + s * 24, y - 4, x + s * 23, y - 24); ctx.fill();
  }
  // glowing eyes
  const pulse = 0.7 + 0.3 * Math.sin(b.t * (rage ? 12 : 4));
  ctx.save(); ctx.shadowColor = C.ember; ctx.shadowBlur = 16 * pulse; ctx.fillStyle = rage && Math.sin(b.t * 20) > 0 ? C.glow : C.white;
  for (const s of [-1, 1]) { ctx.beginPath(); ctx.ellipse(x + s * 12, y - 10, 4.6, 2.4, s * 0.35, 0, TAU); ctx.fill(); }
  ctx.restore();
  // nose and yellow teeth
  ctx.fillStyle = '#2A0606'; ctx.beginPath(); ctx.moveTo(x, y - 1); ctx.lineTo(x - 4, y + 7); ctx.quadraticCurveTo(x, y + 9, x + 4, y + 7); ctx.closePath(); ctx.fill();
  rr(ctx, x - 15, y + 11, 30, 12, 3); ctx.fill();
  ctx.fillStyle = '#F6D21E';
  for (let i = 0; i < 5; i++) { const tx = x - 14 + i * 5.8; rr(ctx, tx, y + 11, 5, 5, 1.2); ctx.fill(); rr(ctx, tx, y + 17.5, 5, 5, 1.2); ctx.fill(); }
}
function drawPumpkin(b) {
  const { x, y, w, h } = b, fl = b.flash > 0, rage = b.hp < b.maxHp / 2, ht = y - h / 2;
  // curling vines
  ctx.strokeStyle = '#2C3B1C'; ctx.lineWidth = 3; ctx.lineCap = 'round';
  for (const s of [-1, 1]) {
    ctx.beginPath(); ctx.moveTo(x + s * 4, ht - 2);
    ctx.bezierCurveTo(x + s * 40, ht - 26, x + s * 74, y - 34, x + s * 68, y + 4);
    ctx.arc(x + s * 61, y + 4, 7, 0, s > 0 ? Math.PI : -Math.PI, s < 0); ctx.stroke();
  }
  // twisted stem
  ctx.fillStyle = '#3A4A22'; ctx.beginPath(); ctx.moveTo(x - 7, ht + 6);
  ctx.quadraticCurveTo(x - 11, ht - 12, x + 2, ht - 22); ctx.lineTo(x + 9, ht - 17);
  ctx.quadraticCurveTo(x, ht - 8, x + 7, ht + 6); ctx.closePath(); ctx.fill();
  // shaded lobes
  [[-0.3, 0.3, C.pumpkinDark], [0.3, 0.3, C.pumpkinDark], [-0.14, 0.3, C.pumpkin], [0.14, 0.3, C.pumpkin], [0, 0.25, C.pumpkin]].forEach(([ox, rx, col]) => {
    const cx = x + ox * w;
    if (fl) ctx.fillStyle = C.white;
    else { const g = ctx.createRadialGradient(cx, y - h * 0.15, 4, cx, y, h * 0.62); g.addColorStop(0, col); g.addColorStop(1, '#4A1C05'); ctx.fillStyle = g; }
    ctx.beginPath(); ctx.ellipse(cx, y, rx * w, h / 2, 0, 0, TAU); ctx.fill();
  });
  ctx.strokeStyle = '#6E2A07'; ctx.lineWidth = 2;
  [-0.16, 0.16].forEach(ox => { ctx.beginPath(); ctx.moveTo(x + ox * w, ht + 5); ctx.quadraticCurveTo(x + ox * w * 1.5, y, x + ox * w, y + h / 2 - 5); ctx.stroke(); });
  // carved face with inner glow
  const pulse = 0.75 + 0.25 * Math.sin(b.t * 3);
  const glow = rage ? (Math.sin(b.t * 16) > 0 ? C.ember : C.glow) : C.glow;
  ctx.save(); ctx.shadowColor = rage ? C.ember : C.glow; ctx.shadowBlur = fl ? 0 : 20 * pulse;
  ctx.fillStyle = fl ? C.pumpkinDark : glow; ctx.beginPath();
  for (const s of [-1, 1]) { ctx.moveTo(x + s * 46, y - 24); ctx.lineTo(x + s * 12, y - 8); ctx.lineTo(x + s * 18, y + 3); ctx.lineTo(x + s * 42, y - 6); ctx.closePath(); }
  ctx.moveTo(x - 6, y + 12); ctx.lineTo(x + 6, y + 12); ctx.lineTo(x, y + 2); ctx.closePath();
  ctx.fill();
  ctx.beginPath(); ctx.moveTo(x - 50, y + 12); ctx.quadraticCurveTo(x, y + 60, x + 50, y + 12);
  [[38, 20], [31, 33], [25, 22], [13, 24], [7, 37], [1, 25], [-1, 25], [-7, 37], [-13, 24], [-25, 22], [-31, 33], [-38, 20]].forEach(([dx, dy]) => ctx.lineTo(x + dx, y + dy));
  ctx.closePath(); ctx.fill();
  // glowing pupils
  ctx.fillStyle = C.white; ctx.shadowColor = C.white; ctx.shadowBlur = 12 * pulse;
  dot(x - 26, y - 7, 3); dot(x + 26, y - 7, 3);
  ctx.restore();
  // lower teeth
  ctx.fillStyle = fl ? C.white : C.pumpkin;
  [[-18, -1], [18, 1]].forEach(([dx]) => { ctx.beginPath(); ctx.moveTo(x + dx - 5, y + 40); ctx.lineTo(x + dx + 5, y + 40); ctx.lineTo(x + dx, y + 28); ctx.closePath(); ctx.fill(); });
}
function drawShot(c) {
  ctx.save(); ctx.translate(c.x, c.y);
  if (c.kind === 'seed') {
    ctx.rotate(Math.atan2(c.vy, c.vx) + Math.PI / 2); ctx.shadowColor = C.glow; ctx.shadowBlur = 8; ctx.fillStyle = '#F3E3B5'; ctx.beginPath(); ctx.ellipse(0, 0, 3, 5, 0, 0, TAU); ctx.fill();
  } else if (c.kind === 'flame') {
    ctx.rotate(Math.atan2(c.vy, c.vx) + Math.PI / 2); ctx.shadowColor = C.ember; ctx.shadowBlur = 10;
    ctx.fillStyle = C.hellRed; ctx.beginPath(); ctx.arc(0, -2, 5, Math.PI, 0);
    ctx.quadraticCurveTo(4, 5, 0, 12 + Math.sin(S.t * 30) * 2); ctx.quadraticCurveTo(-4, 5, -5, -2); ctx.fill();
    ctx.shadowBlur = 0; ctx.fillStyle = C.orange; dot(0, -1, 3.2); ctx.fillStyle = C.glow; dot(0, -1.5, 1.6);
  } else {
    ctx.rotate(c.rot); ctx.fillStyle = c.col || C.orange;
    ctx.beginPath(); ctx.moveTo(-3, 0); ctx.lineTo(-7, -3); ctx.lineTo(-7, 3); ctx.closePath(); ctx.moveTo(3, 0); ctx.lineTo(7, -3); ctx.lineTo(7, 3); ctx.closePath(); ctx.fill();
    dot(0, 0, 3.6); ctx.fillStyle = C.white; dot(-1, -1, 1);
  }
  ctx.restore();
}
const ENEMY_DRAW = { candyCorn: drawCandyCorn, ghost: drawGhost, bat: drawBat };
function drawAsteroid(a) {
  ctx.save(); ctx.translate(a.x, a.y); ctx.rotate(a.rot);
  ctx.beginPath(); a.pts.forEach((r, i) => { const ang = i / a.pts.length * TAU; i ? ctx.lineTo(Math.cos(ang) * r, Math.sin(ang) * r) : ctx.moveTo(Math.cos(ang) * r, Math.sin(ang) * r); });
  ctx.closePath(); ctx.fillStyle = a.flash > 0 ? C.white : C.rock; ctx.fill(); ctx.strokeStyle = C.rockEdge; ctx.lineWidth = 2; ctx.stroke();
  ctx.fillStyle = C.rockEdge; ctx.beginPath(); ctx.arc(-a.r * 0.3, -a.r * 0.2, a.r * 0.18, 0, TAU); ctx.arc(a.r * 0.3, a.r * 0.3, a.r * 0.13, 0, TAU); ctx.fill();
  ctx.restore();
}
function pouchPath(w, h) {
  ctx.beginPath(); ctx.moveTo(-w / 2, -h / 2); ctx.lineTo(w / 2, -h / 2); ctx.lineTo(w / 2 - 1, h / 2 - 4);
  ctx.quadraticCurveTo(w / 2 - 1, h / 2, w / 2 - 5, h / 2); ctx.lineTo(-w / 2 + 5, h / 2);
  ctx.quadraticCurveTo(-w / 2 + 1, h / 2, -w / 2 + 1, h / 2 - 4); ctx.closePath();
}
function drawPacket(p) {
  const w = 22, h = 30;
  ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot);
  const img = p.kind === 'gold' ? IMG.golden : p.kind === 'mystery' ? IMG.mystery : IMG.packets.length ? IMG.packets[p.flav % IMG.packets.length] : null;
  if (p.kind !== 'std') { ctx.shadowColor = p.kind === 'gold' ? (imgReady(IMG.golden) ? C.ember : C.gold) : C.lime; ctx.shadowBlur = 10 + Math.sin(S.t * 6) * 5; }
  if (imgReady(img)) {
    const ar = img.naturalWidth / img.naturalHeight, dh = p.kind === 'gold' ? 40 : 34, dw = dh * ar; ctx.drawImage(img, -dw / 2, -dh / 2, dw, dh);
  } else if (p.kind === 'std') {
    const col = CONFIG.FLAVOURS[p.flav];
    pouchPath(w, h); ctx.fillStyle = '#000'; ctx.fill(); ctx.strokeStyle = col; ctx.lineWidth = 1.6; ctx.stroke();
    ctx.fillStyle = '#2A2A2A'; ctx.fillRect(-w / 2 + 1, -h / 2 + 1, w - 2, 3);
    ctx.fillStyle = C.white; ctx.beginPath(); ctx.arc(0, -7, 3.2, 0, TAU); ctx.fill();
    ctx.fillStyle = col; ctx.fillRect(-w / 2 + 1, 0, w - 2, 6);
    ctx.fillStyle = C.white; ctx.fillRect(-6, 9, 12, 2);
  } else if (p.kind === 'gold') {
    const g = ctx.createLinearGradient(-w / 2, -h / 2, w / 2, h / 2); g.addColorStop(0, '#FFE58A'); g.addColorStop(1, '#B8872A');
    pouchPath(w, h); ctx.fillStyle = g; ctx.fill(); ctx.shadowBlur = 0;
    ctx.fillStyle = C.bg; ctx.beginPath(); ctx.arc(0, -6, 3.2, 0, TAU); ctx.fill(); ctx.fillRect(-7, 2, 14, 5);
  } else {
    pouchPath(w, h); ctx.fillStyle = C.lime; ctx.fill(); ctx.shadowBlur = 0;
    ctx.fillStyle = C.bg; ctx.font = `900 16px ${DISPLAY}`; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('?', 0, 2);
  }
  ctx.restore();
}
function alienIcon(x, y, s, lit) {
  ctx.globalAlpha = lit ? 1 : 0.22;
  rr(ctx, x, y, s, s, s * 0.22); ctx.fillStyle = C.bg; ctx.fill(); ctx.strokeStyle = C.lime; ctx.lineWidth = s * 0.17; ctx.stroke();
  ctx.fillStyle = C.white;
  ctx.beginPath(); ctx.ellipse(x + s * 0.33, y + s * 0.45, s * 0.13, s * 0.07, 0.6, 0, TAU); ctx.fill();
  ctx.beginPath(); ctx.ellipse(x + s * 0.67, y + s * 0.45, s * 0.13, s * 0.07, -0.6, 0, TAU); ctx.fill();
  ctx.globalAlpha = 1;
}
function drawHUD() {
  ctx.textBaseline = 'top'; ctx.textAlign = 'left';
  ctx.fillStyle = C.limeSoft; ctx.font = `700 9px ${DISPLAY}`; ctx.fillText('SCORE', 14, 12);
  ctx.fillStyle = C.lime; ctx.font = `900 20px ${DISPLAY}`; ctx.fillText(String(S.score).padStart(5, '0'), 14, 23);
  ctx.fillStyle = C.limeSoft; ctx.font = `700 10px ${DISPLAY}`; ctx.fillText(`WAVE ${S.wave}/${CONFIG.WAVES}`, 14, 50);
  if (S.combo >= 2) { ctx.fillStyle = C.lime; ctx.font = `800 10px ${DISPLAY}`; ctx.fillText(`COMBO ${S.combo}  x${comboMult()}`, 14, 66); }
  const s = 14, gap = 5, tw = CONFIG.LIVES * s + (CONFIG.LIVES - 1) * gap;
  for (let i = 0; i < CONFIG.LIVES; i++) alienIcon(W / 2 - tw / 2 + i * (s + gap), 42, s, i < S.lives);
  if (S.doubleT > 0) { ctx.textAlign = 'right'; ctx.fillStyle = C.gold; ctx.font = `800 11px ${DISPLAY}`; ctx.fillText(`2X POINTS ${Math.ceil(S.doubleT)}s`, W - 14, 58); }
  if (boss) {
    const bw = 180, x = W / 2 - bw / 2, y = groundTop + 24;
    const bc = BOSS_COL[boss.kind];
    ctx.textAlign = 'center'; ctx.fillStyle = bc; ctx.font = `800 9px ${DISPLAY}`; ctx.fillText(CONFIG.BOSS_NAMES[boss.kind], W / 2, y - 14);
    rr(ctx, x, y, bw, 7, 3.5); ctx.fillStyle = 'rgba(255,255,255,.12)'; ctx.fill();
    rr(ctx, x, y, Math.max(7, bw * boss.hp / boss.maxHp), 7, 3.5); ctx.fillStyle = bc; ctx.fill();
  }
}
function drawBanner() {
  const b = S.banner; if (!b) return;
  const a = Math.min(1, b.t / 0.4, (2.4 - b.t) / 0.25 + 0.01);
  ctx.globalAlpha = clamp(a, 0, 1); ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  ctx.fillStyle = C.lime; ctx.font = `400 36px ${HEADING}`; ctx.fillText(b.text, W / 2, H * 0.4);
  ctx.fillStyle = C.white; ctx.font = `600 16px ${FONT}`; ctx.fillText(b.sub, W / 2, H * 0.4 + 36);
  ctx.globalAlpha = 1;
}

function render() {
  ctx.setTransform(dpr * scale, 0, 0, dpr * scale, 0, 0);
  ctx.fillStyle = C.bg; ctx.fillRect(0, 0, W, H);
  ctx.save();
  if (S.shake > 0) ctx.translate(rand(-S.shake, S.shake) / 2, rand(-S.shake, S.shake) / 2);
  drawStars();
  if (bdBack) ctx.drawImage(bdBack, 0, 0, bdBack.width, bdBack.height, 0, 0, W, H);

  const playing = S.mode !== 'title';
  if (playing) {
    const f = S.formation && Math.floor(S.formation.anim / 0.4) % 2;
    enemies.forEach(e => { if (e.alive) ENEMY_DRAW[e.type](e, f); });
    if (boss) (boss.kind === 'pumpkin' ? drawPumpkin : drawReaper)(boss);
  }
  if (bdFront) ctx.drawImage(bdFront, 0, 0, bdFront.width, bdFront.height, 0, 0, W, H);

  if (playing && player) {
    asteroids.forEach(drawAsteroid);
    if (S.beaming && S.mode === 'play') drawBeam(player.x, player.y);
    packets.forEach(drawPacket);
    ctx.fillStyle = C.lime;
    lasers.forEach(l => { ctx.fillStyle = C.lime; ctx.fillRect(l.x - 2, l.y - 7, 4, 14); ctx.fillStyle = C.white; ctx.fillRect(l.x - 0.75, l.y - 5, 1.5, 10); });
    crumbs.forEach(drawShot);
    if (S.mode !== 'dying' && S.mode !== 'over' && !(S.invuln > 0 && Math.floor(S.t * 12) % 2)) drawUFO(player.x, player.y, player.tilt, S.beaming);
  } else {
    // attract mode on the title screen
    const x = W / 2 + Math.sin(S.t * 0.8) * 60, y = UFO_Y + Math.sin(S.t * 2) * 4;
    drawBeam(x, y); drawUFO(x, y, Math.cos(S.t * 0.8) * 0.08, true);
  }
  particles.forEach(p => { ctx.globalAlpha = clamp(p.life / 0.5, 0, 1); ctx.fillStyle = p.col; ctx.fillRect(p.x - p.s / 2, p.y - p.s / 2, p.s, p.s); });
  ctx.globalAlpha = 1;
  ctx.restore();

  if (playing) {
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    floaters.forEach(f => { ctx.globalAlpha = clamp(f.t * 1.5, 0, 1); ctx.fillStyle = f.col; ctx.font = `800 ${Math.round(f.size * 0.85)}px ${DISPLAY}`; ctx.fillText(f.text, f.x, f.y); });
    ctx.globalAlpha = 1;
    drawHUD(); drawBanner();
  }
}

/* ---------- loop ---------- */
let last = performance.now();
function loop(now) {
  const dt = Math.min(0.033, (now - last) / 1000); last = now;
  if (S.mode === 'play' || S.mode === 'dying') update(dt);
  else if (S.mode === 'title') S.t += dt;
  else if (S.mode === 'over') { S.t += dt; updateEffects(dt); }
  if (inView) render();
  if (alive) rafId = requestAnimationFrame(loop);
}

/* ---------- input ---------- */
on(canvas, 'pointerdown', e => {
  if (S.mode !== 'play' || !player) return;
  input.dragId = e.pointerId; input.dragStartX = e.clientX; input.dragUfoX = player.x; input.targetX = player.x;
  try { canvas.setPointerCapture(e.pointerId); } catch (_) {}
});
on(canvas, 'pointermove', e => {
  if (e.pointerId !== input.dragId) return;
  input.targetX = clamp(input.dragUfoX + (e.clientX - input.dragStartX) / scale * 1.25, 32, W - 32);
});
const endDrag = e => { if (e.pointerId === input.dragId) input.dragId = null; };
on(canvas, 'pointerup', endDrag); on(canvas, 'pointercancel', endDrag);

beamBtn.addEventListener('pointerdown', e => { e.preventDefault(); sfx.init(); input.beamTouch = true; try { beamBtn.setPointerCapture(e.pointerId); } catch (_) {} });
['pointerup', 'pointercancel', 'lostpointercapture'].forEach(ev => beamBtn.addEventListener(ev, () => { input.beamTouch = false; }));
beamBtn.addEventListener('contextmenu', e => e.preventDefault());
// Wake audio back up after phone calls, app switching or the screen locking (taps inside the game only,
// so tapping the site menu never grabs the phone's audio)
on(root, 'pointerdown', () => { if (sfx.ctx && S.mode === 'play') sfx.init(); }, true);

const keyMap = { ArrowLeft: 'left', a: 'left', A: 'left', ArrowRight: 'right', d: 'right', D: 'right', ' ': 'beamKey', Shift: 'beamKey', ArrowDown: 'beamKey', s: 'beamKey', S: 'beamKey' };
// Keys belong to the game only while it's on screen, and never while someone is typing (search box, email pop-ups)
const typing = t => !!(t && t.closest && t.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])'));
on(window, 'keydown', e => {
  if (e.ctrlKey || e.metaKey || e.altKey || typing(e.target) || !inView) return;
  if (S.mode === 'play' && keyMap[e.key]) { input[keyMap[e.key]] = true; e.preventDefault(); }
  if ((e.key === 'p' || e.key === 'P' || e.key === 'Escape') && (S.mode === 'play' || S.mode === 'paused')) { setPaused(S.mode === 'play'); e.preventDefault(); }
  if (S.mode === 'title' && (root.contains(document.activeElement) || document.activeElement === document.body)) {
    if (e.key === 'Enter') { e.preventDefault(); if ($('brief').hidden) openBrief(); else startGame(); }
    else if (e.key === 'Escape' && !$('brief').hidden) { e.preventDefault(); closeBrief(); }
  }
});
on(window, 'keyup', e => { if (keyMap[e.key]) input[keyMap[e.key]] = false; });
on(window, 'blur', () => { input.left = input.right = input.beamKey = input.beamTouch = false; setPaused(true); });
on(document, 'visibilitychange', () => { if (document.hidden) { setPaused(true); sfx.sleep(); } });

// Mission briefing pop-up: ACCEPT MISSION opens it, its START button begins the game
function openBrief() { $('brief').hidden = false; $('briefStart').focus({ preventScroll: true }); }
function closeBrief() { $('brief').hidden = true; $('startBtn').focus({ preventScroll: true }); }
$('startBtn').addEventListener('click', openBrief);
$('briefStart').addEventListener('click', startGame);
$('briefClose').addEventListener('click', closeBrief);
$('brief').addEventListener('click', e => { if (e.target === $('brief')) closeBrief(); });
$('againBtn').addEventListener('click', startGame);
$('resumeBtn').addEventListener('click', () => setPaused(false));
$('quitBtn').addEventListener('click', goTitle);
$('pauseBtn').addEventListener('click', () => setPaused(true));
$('soundBtn').addEventListener('click', e => { sfx.init(); sfx.setOn(!sfx.on); e.currentTarget.setAttribute('aria-pressed', String(sfx.on)); });
$('crtBtn').addEventListener('click', e => { const off = frame.classList.toggle('crt-off'); e.currentTarget.setAttribute('aria-pressed', String(!off)); });

/* ---------- boot ---------- */
if (!CONFIG.CRT_DEFAULT) { frame.classList.add('crt-off'); $('crtBtn').setAttribute('aria-pressed', 'false'); }
['coords', 'coordsEnd'].forEach(id => { const el = $(id); el.textContent = CONFIG.COORDINATES ? 'SIGNAL ORIGIN  ' + CONFIG.COORDINATES : ''; el.hidden = !CONFIG.COORDINATES; });
if (document.fonts && document.fonts.load) ['900 20px Orbitron', '800 10px Orbitron', '400 36px Kusanagi'].forEach(f => document.fonts.load(f).catch(() => {}));
$('howText').textContent = `Survive ${CONFIG.WAVES} waves and the aliens will unlock what they've been hiding.`;
const pImg = $('productImg');
if (CONFIG.PRODUCT_IMAGE) { pImg.onload = () => { pImg.hidden = false; }; pImg.alt = CONFIG.PRODUCT_NAME; pImg.src = CONFIG.PRODUCT_IMAGE; }
// Transmission types itself out on the start screen
(() => {
  const el = $('txText'), full = CONFIG.TRANSMISSION.toUpperCase();
  if (RM) { el.textContent = full; return; }
  let i = 0; const tick = () => { el.textContent = full.slice(0, ++i); if (i < full.length) later(tick, 45); };
  later(tick, 500);
})();
// Logos only appear once they've loaded, so a missing file never shows a broken image
const logoRound = $('logoRound'), hudLogo = $('hudLogo');
if (CONFIG.LOGO_ROUND) { logoRound.onload = () => { logoRound.hidden = false; }; logoRound.src = CONFIG.LOGO_ROUND; }
if (CONFIG.LOGO_HORIZONTAL) { hudLogo.onload = () => { hudLogo.dataset.ok = '1'; if (S.mode === 'play' || S.mode === 'paused') hudLogo.hidden = false; }; hudLogo.src = CONFIG.LOGO_HORIZONTAL; }
on(window, 'resize', resize);
let ro = null;
if (window.ResizeObserver) { ro = new ResizeObserver(() => resize()); ro.observe(stage); cleanups.push(() => ro.disconnect()); }
resize();
rafId = requestAnimationFrame(loop);

instances.set(root, () => {
  alive = false; cancelAnimationFrame(rafId);
  cleanups.forEach(fn => { try { fn(); } catch (_) {} });
  sfx.destroy();
});
}

function kill(root) { const stop = instances.get(root); if (stop) { stop(); instances.delete(root); } }
const bootAll = scope => (scope || document).querySelectorAll('[data-ufo-game]').forEach(boot);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bootAll()); else bootAll();
// Theme editor: sections are re-rendered in place when settings change
document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-ufo-game]').forEach(kill));
document.addEventListener('shopify:section:load', e => bootAll(e.target));
})();